import { utagLinkSort } from 'features/tealium/';

import doSaleSearch from './doSaleSearch';

const initSaleSearch = (searchInputSelector, searchBtnSelector) => {

	const trackSearchBoxEvents = utagLinkSort();
	const searchInput = document.querySelector(searchInputSelector);
	const searchBtn = document.querySelector(searchBtnSelector);
	let eventCalled = false;

	if (!searchInput) {

		return;

	}

	const searchHandler = (e) => {

		e.preventDefault();

		const value = searchInput.value.trim();

		if (value === '') {

			return;

		}
		if (!eventCalled) {

			trackSearchBoxEvents({
				eventAction: 'Sale-Search-Submit',
				eventLabel: value.toLowerCase()
			});

			eventCalled = true;

		}
		doSaleSearch(searchInput.value.trim());

	};

	searchBtn.addEventListener('click', (e) => {

		searchHandler(e);

	});

	searchInput.addEventListener('keydown', (e) => {

		if (e.key === 'Enter') {

			searchHandler(e);

		}

	});

};

export default initSaleSearch;
